import React, { useEffect, useState } from 'react'
import axios from 'axios'
import CustomProfile from '../../Components/DMM/Assistant/CustomProfile'
import { DMM_API_HOST, DMM_API_KEY } from '../../_Components/Common/common'
import { Pagination } from 'react-bootstrap'

const index = () => {
  const [status, setStatus] = useState('P')
  const [pageNumber, setPageNumber] = useState(1)
  const [pageMap, setPageMap] = useState({})
  const [profileList, setProfileList] = useState([])

  useEffect(() => {
    getCustomProfile(1)
    setPageNumber(1)
  }, [status])

  useEffect(() => {
    getCustomProfile()
  }, [pageNumber])

  const getCustomProfile = async n => {
    await axios
      .get(
        `${DMM_API_HOST}/v4.0.1/assistant/customProfile?status=${status}&pageNumber=${
          n ? n : pageNumber
        }&limit=15`,
        {
          headers: {
            apikey: DMM_API_KEY,
          },
        }
      )
      .then(({ data }) => {
        console.log(data.body.profileList)
        setProfileList(data.body.profileList)
        setPageMap(data.body.pageMap)
      })
  }

  const updateCustomProfile = async (assistantId, status) => {
    await axios
      .put(
        `${DMM_API_HOST}/v4.0.1/assistant/customProfile/${assistantId}`,
        { status },
        {
          headers: {
            apikey: DMM_API_KEY,
          },
        }
      )
      .then(() => {
        getCustomProfile()
      })
  }

  const renderPaging = (pageNumber, pageMap) => {
    let list = []
    let j = 0
    let i = 0

    let test = pageNumber !== 1 ? pageNumber - 1 : 1
    let last =
      pageNumber !== pageMap.pageCount ? pageNumber * 1 + 1 : pageMap.pageCount

    list.push(
      <Pagination.Item
        key="first"
        onClick={() => {
          setPageNumber(test)
        }}
      >
        &laquo;
      </Pagination.Item>
    )

    for (i = pageMap.startPage * 1; i <= pageMap.endPage; i++) {
      let num = pageMap.startPage * 1 + j

      if (num === pageMap.pageNumber * 1) {
        list.push(
          <Pagination.Item key={i} className="active">
            {num}
          </Pagination.Item>
        )
      } else {
        list.push(
          <Pagination.Item
            key={i}
            onClick={() => {
              setPageNumber(num)
            }}
          >
            {num}
          </Pagination.Item>
        )
      }
      j++
    }

    list.push(
      <Pagination.Item
        key="last"
        onClick={() => {
          setPageNumber(last)
        }}
      >
        &raquo;
      </Pagination.Item>
    )
    return <Pagination>{list}</Pagination>
  }

  const deleteAssistant = async assistantId => {
    await axios
      .delete(`${DMM_API_HOST}/v4.0.1/assistant/${assistantId}`, {
        headers: {
          apikey: DMM_API_KEY,
        },
      })
      .then(() => {
        axios
          .delete(
            `${DMM_API_HOST}/v4.0.1/assistant/customProfile/${assistantId}`,
            {
              headers: {
                apikey: DMM_API_KEY,
              },
            }
          )
          .then(() => {
            getCustomProfile()
          })
      })
  }

  const updateAssistantStatus = async assistantId => {
    await axios
      .put(
        `${DMM_API_HOST}/v4.0.1/assistant/${assistantId}/status`,
        { status: 'U' },
        {
          headers: {
            apikey: DMM_API_KEY,
          },
        }
      )
      .then(() => {
        getCustomProfile()
        window.alert('Unlisted 변경 완료')
      })
  }

  return (
    <>
      <CustomProfile
        profileList={profileList}
        status={status}
        setStatus={setStatus}
        getCustomProfile={getCustomProfile}
        updateCustomProfile={updateCustomProfile}
        deleteAssistant={deleteAssistant}
        updateAssistantStatus={updateAssistantStatus}
      />
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        {pageMap && renderPaging(pageNumber, pageMap)}
      </div>
    </>
  )
}

export default index
